import React from 'react';

const Background = ({ children }) => (
  <div
    style={{
      backgroundColor: '#f0efee',
      height: '100%',
      minWidth: '1024px',
      overflowX: 'visible',
      position: 'relative'
    }}
  >
    {children}
  </div>
);

export default Background;